<div id="wrap" class="moWrap">
  <header class="header">
      <div class="header_inner">
          <h1 class="header_logo">
              <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
          </h1>
          <span class="util_right">
              <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
          </span>
      </div>
  </header>

  <div id="content">
    <div id="skip_anchor" class="content page_account autoWd">
        <div class="form_account">
            <strong class="account_title">비밀번호 재발급</strong>
            <div class="account_box required_group">
                <fieldset *ngIf="!isOtpConfirm">
                    <p class="account_subscript">&#8251;개인정보 보호를 위하여 본인 확인이 필요합니다. <br />비밀번호를 찾고자하는 아이디를 입력해 주세요.</p>
                    <div class="account_form">
                        <label>아이디</label>
                        <input type="text" [(ngModel)]="userId" class="form_input required" placeholder="아이디를 입력해 주세요."/>
                        <button type="button" class="form_button btn_required" (click)="findPwSend()" [disabled]="isOtpSend">확인</button>
                    </div>
                    <div class="account_form">
                        <label>핸드폰 번호</label>
                        <input type="text" [(ngModel)]="tel" [disabled]="true" class="form_input required"/>
                    </div>
                    <div class="account_form">
                        <label>인증번호 입력</label>
                        <input type="text" [(ngModel)]="otpCode" (keyup.enter)="otpCheck()" [disabled]="!isOtpSend" class="form_input required" placeholder="인증번호를 입력해 주세요." />
                        <span *ngIf="isOtpSend || isOtpConfirmTry" class="form_timer">{{displayTime}}</span>
                        <button type="button" class="form_button btn_required" (click)="otpCheck()" [disabled]="!isOtpSend || isOtpConfirm">확인</button>
                    </div>
                </fieldset>

                <fieldset *ngIf="isOtpConfirm">
                    <p class="account_subscript">&#8251;비밀번호는 영문, 숫자를 조합하여 최소 10자리 이상 입력해 주세요.</p>
                    <div class="account_form">
                        <label>아이디</label>
                        <input type="text" [(ngModel)]="userId" class="form_input required" [disabled]="true"/>
                    </div>
                    <div class="account_form">
                        <label>새 비밀번호</label>
                        <input type="password" [(ngModel)]="password" (keyup)="checkPassword()" class="form_input required" placeholder="비밀번호를 입력해 주세요."/>
                        <p *ngIf="passwdCheckMsg" class="form_msg">{{passwdCheckMsg}}</p>
                    </div>
                    <div class="account_form">
                        <label>새 비밀번호 확인</label>
                        <input type="password" [(ngModel)]="passwordConfirm" (keyup)="checkConfirmPassword()" class="form_input required" placeholder="비밀번호를 한번 더 입력해 주세요."/>
                        <p *ngIf="confirmPasswdCheckMsg" class="form_msg">{{confirmPasswdCheckMsg}}</p>
                    </div>
                    <div class="btn">
                      <button class="btn_item btn_required" (click)="updatePassword()">비밀번호 재발급</button>
                    </div>
                </fieldset>
            </div>
        </div>
    </div>
  </div>
  <footer class="footer">
    <div class="footer_inner">
        <div class="footer_menu">
            <a routerLink="/m/guide">이용가이드</a>
            <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="emphasis">개인정보처리방침</a>
            <a routerLink="/terms">약관 및 정책</a>
        </div>
    </div>
  </footer>
</div>
